'use strict';

var _ = require('lodash');
var d3 = require('d3');
var RomSummaryMaxActMinRevenueScales = function RomSummaryMaxActMinRevenueScales(params, data, range) {
  var yMin = d3.min(data, function (d) {
    return d3.min(d.curveData, function (element) {
      return element.value;
    });
  });
  var yMax = d3.max(data, function (d) {
    return d3.max(d.curveData, function (element) {
      return element.value;
    });
  });
  var y = d3.scale.linear().domain([yMin, yMax]).rangeRound([params.height, 0]);
  var domain;
  if (range) {
    domain = data[0].curveData.slice(range[0], range[1]);
  } else {
    domain = data[0].curveData;
  }
  function calculateWidth() {
    var width = params.width;
    var dataLength = data[0].curveData.length;
    if (params.width / dataLength > params.maxGroupWidth) {
      width = params.maxGroupWidth * dataLength;
    }
    return width;
  }
  var width, offset;
  if (params.maxGroupWidth) {
    width = calculateWidth();
    offset = (params.width - width) / 2;
  } else {
    width = params.width;
    offset = 0;
  }
  var x = d3.scale.ordinal().domain(_.map(domain, 'dimension')).rangeBands([offset, width + offset], 0.2, 0.1);
  return {
    xScale: x,
    yScale: y
  };
};
RomSummaryMaxActMinRevenueScales.$inject = [];
module.exports = RomSummaryMaxActMinRevenueScales;